import CustomSplitDomainListsDashboard from "./CustomSplitDomainListsDashboard";

export default CustomSplitDomainListsDashboard;
